import { createFileRoute } from '@tanstack/react-router'

import NotificationsList from './-components/list/notification-table'

export const Route = createFileRoute('/dashboard/admin/notification/')({
  component: View,
})

function View() {
  return (
    <div className="container absolute inset-0 mx-auto py-10">
      <NotificationsList />
    </div>
  )
}
